export const FETCHING_ROOMS = 'FETCHING_ROOMS';
export const FETCHED_ROOMS = 'FETCHED_ROOMS';
export const GET_TOPICS = 'GET_TOPICS';
export const FOLLOW_ACTION = 'FOLLOW_ACTION';
export const BOOKMARK_ACTION = 'BOOKMARK_ACTION';
export const RESET_FETCHED_ROOMS = 'RESET_FETCHED_ROOMS'
export const GET_REPORT_REASONS = 'GET_REPORT_REASONS'
export const NOTIFY_ME='NOTIFY_ME';